import { render, staticRenderFns } from "./BreakModel.vue?vue&type=template&id=3b3a1f3c"
import script from "./BreakModel.vue?vue&type=script&lang=js"
export * from "./BreakModel.vue?vue&type=script&lang=js"
import style0 from "./BreakModel.vue?vue&type=style&index=0&id=3b3a1f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports